module.exports = __webpack_public_path__ + "static/img/anxun62.c24705c6.png";